import { useEffect, useState } from 'react';

import { type Pod } from '@rtkwlf/c3-lib-pods';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Outlet } from 'react-router-dom';

import { organizationQuery } from '@apis/eloc/queries/organization';
import { organizations } from '@apis/tasks/organizations.store';
import { useOrganizationParam } from '@packages/hooks/use-organization-param';

export const Layout = () => {
  /**
   * tracks the current orgId for the purposes of deferring rendering
   * of children until after the organizations have been fetched and the
   * organizations store has been updated. Since middleware in react router is still
   * unstable, this is the easiest way to defer rendering of outlets
   */
  const [currOrgId, setCurrOrgId] = useState<string | null>(null);

  /**
   * Get the organizationID from the url
   */
  const orgId = useOrganizationParam();

  /**
   * Fetch the organization from eloc
   */
  const { data: organization } = useSuspenseQuery({
    ...organizationQuery(orgId),
  });

  useEffect(() => {
    if (currOrgId !== orgId) {
      organizations.setOrganizations([
        {
          orgID: organization.id,
          name: organization.name,
          consoleID: organization.customerID,
          pod: organization.pod as Pod,
        },
      ]);
      setCurrOrgId(orgId);
    }
  }, [currOrgId, orgId, organization, setCurrOrgId]);

  /**
   * Eloc will have already cached the current org at this point
   * so we can skip rendering some loading
   */
  if (currOrgId !== orgId) {
    return null;
  }

  return <Outlet />;
};
